import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateCustomReport } from '../../service/customReportService'
import { CustomReport } from '../../../../redux/context/customReports/types'
import customReportQueryKeys from '../customReportQueryKeys'
import { showSuccessMessage, showErrorMessage } from '../../../../utils/message'

export interface UpdateCustomReportOptions {
  showSuccess?: boolean
  skipInvalidation?: boolean
}

export const useUpdateCustomReport = (companyId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ data }: { data: Partial<CustomReport>; options?: UpdateCustomReportOptions }) => {
      if (data.id === undefined) throw new Error('Report ID is required for update')
      if (!companyId) throw new Error('Company ID is required for update')
      return updateCustomReport(data.id, data, companyId)
    },
    onSuccess: (response, { data, options }) => {
      if (options?.showSuccess !== false) showSuccessMessage()
      if (options?.skipInvalidation) {
        queryClient.setQueryData(customReportQueryKeys.detail(companyId, data.id), (old: CustomReport | undefined) =>
          old ? { ...old, ...data } : response
        )
        return
      }
      queryClient.invalidateQueries({ queryKey: customReportQueryKeys.detail(companyId, data.id) })
      queryClient.invalidateQueries({ queryKey: customReportQueryKeys.list(companyId) })
    },
    onError: () => showErrorMessage()
  })
}
